import { FC, useContext, useMemo } from "react";
import { EcdTrendingArrowEnum } from "../interfaces";
import { EcdColorsContext } from "../contexts/EcdColorsContext";
import { getTrendingArrow } from "../utility";

interface EnterpriseComplianceDashboardChartHeaderProps {
    trendArrow: EcdTrendingArrowEnum;
    label: string;
    number: number;
    percentage?: number;
}

const EnterpriseComplianceDashboardChartHeader: FC<EnterpriseComplianceDashboardChartHeaderProps> = (props: EnterpriseComplianceDashboardChartHeaderProps) => {
    const colorsContext = useContext(EcdColorsContext);
    const hasPercentage = !isNaN(props.percentage) && !!props.percentage;

    const arrowColor = useMemo(() => {
        switch (props.trendArrow) {
            case EcdTrendingArrowEnum.RedDown:
            case EcdTrendingArrowEnum.RedUp:
                return colorsContext.arrowNegative;
            case EcdTrendingArrowEnum.BlueDown:
            case EcdTrendingArrowEnum.BlueUp:
                return colorsContext.arrowPositive;
            default:
                return "";
        }
    }, [props.trendArrow, colorsContext.arrowNegative, colorsContext.arrowPositive]);

    return (
        <div className="qes-dashboard-tile__chart-header">
            <div className="d-inline-flex flex-column">
                <span className="title">
                    {!isNaN(props.number) ? props.number.toLocaleString() : "---"}
                    <span className="subtitle">{props.label}</span>
                </span>
            </div>
            {hasPercentage && (
                <span className="descriptor" style={{ color: arrowColor }}>
                    {props.percentage?.toLocaleString()}%
                    {getTrendingArrow(props.trendArrow, colorsContext)}
                </span>
            )}
        </div>
    )
}

export default EnterpriseComplianceDashboardChartHeader;
